import { render, staticRenderFns } from "./OrganizationFormScreen.vue?vue&type=template&id=8c65d038&"
import script from "./OrganizationFormScreen.vue?vue&type=script&lang=ts&"
export * from "./OrganizationFormScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports